const selectedItemsList = {
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: '480px',
  gap: '5px',
  marginTop: '10px',
};

export { selectedItemsList };
